import React from "react";
import { BrowserUtil } from "@util/index";
import SpecialLifeAtButton from "../../LifeAtButton/Variants/SpecialLifeAtButton";
import LifeAtModal from "../LifeAtModal";

const MODAL_TITLE = "LifeAt cannot connect";
const REFRESH_BUTTON_LABEL = "Reload LifeAt";

function AppOfflineAlertModal() {
    return (
        <LifeAtModal title={MODAL_TITLE} isOpen closeModal={() => {}} preventClose centerContent>
            <SpecialLifeAtButton
                isLink={false}
                text={REFRESH_BUTTON_LABEL}
                variant="blue"
                handleClick={() => BrowserUtil.reloadPage()}
            />
        </LifeAtModal>
    );
}
export default AppOfflineAlertModal;
